import '@babel/polyfill';
import Vue from 'vue';
import App from './components/App';
import store from './store';
import router from './router';
import VueKonva from 'vue-konva';
import VueI18n from 'vue-i18n';
import messages from './Locallang';
import {containerSelector} from "@/common/config";

import Quasar, {
	QAvatar,
	QBadge,
	QBtn,
	QBtnDropdown,
	QBtnGroup,
	QCard,
	QCardActions,
	QCardSection,
	QCheckbox,
	QDate,
	QDialog,
	QDrawer,
	QField,
	QFooter,
	QHeader,
	QIcon,
	QImg,
	QInfiniteScroll,
	QInput,
	QItem,
	QItemLabel,
	QItemSection,
	QLayout,
	QList,
	QMarkupTable,
	QMenu,
	QPage,
	QPageContainer,
	QPagination,
	QPopupProxy,
	QRouteTab,
	QScrollArea,
	QSelect,
	QSeparator,
	QSlideTransition,
	QSpace,
	QSpinnerCube,
	QSpinnerDots,
	QStep,
	QStepper,
	QStepperNavigation,
	QTab,
	QTable,
	QTabPanel,
	QTabPanels,
	QTabs,
	QTd,
	QToggle,
	QToolbar,
	QTooltip,
	QTr,
	QInnerLoading
} from "quasar/dist/quasar.esm";
import "quasar/dist/quasar.css";
import "quasar/icon-set/material-icons";
import langDe from 'quasar/lang/de';
import langEn from 'quasar/lang/en-gb';
import Notify from "quasar/src/plugins/Notify";
import Dialog from "quasar/src/plugins/Dialog";
import moment from "moment";
import {RESTORE_LOCAL_STORAGE_DATA} from "@/store/actions.type";

Notify.setDefaults({
	color: "primary"
});

const container = document.querySelector(containerSelector);
if (container) {
	const lang = parseInt(container.dataset.lang) === 1 ? langEn : langDe,
		langIso = lang.isoName.replace(/-.*/, '');

	Vue.use(VueKonva);
	Vue.use(VueI18n);
	Vue.use(Quasar, {
		components: [
			QLayout, QHeader, QPageContainer, QPage, QFooter, QDrawer,
			QToolbar, QBtnGroup, QBtnDropdown, QBtn, QCard, QCardActions, QCardSection,
			QTabs, QTab, QRouteTab, QSeparator, QList, QItemSection, QItem, QItemLabel,
			QField, QInput, QSelect, QDialog, QMenu, QSlideTransition, QIcon,
			QImg, QSpinnerCube, QSpinnerDots, QTabPanels, QTabPanel, QCheckbox, QPagination,
			QTable, QTr, QTd, QAvatar, QSpace, QTooltip, QInfiniteScroll, QToggle, QDate,
			QPopupProxy, QScrollArea, QBadge, QStepper, QStep, QStepperNavigation, QMarkupTable,
			QInnerLoading
		],
		plugins: [Notify, Dialog],
		config: {
			brand: {
				primary: '#006751',
				secondary: '#858585',
				accent: '#b6b6b6',
				accentText: '#222222',

				positive: '#21BA45',
				negative: '#C10015',
				info: '#31CCEC',
				warning: '#F2C037'
			}
		},
		lang: lang
	});

	new Vue({
		// set container element
		el: '#warehouse',
		// make the whole application store aware, short for store: store
		store,
		// make the whole application router aware, short for router: router
		router,
		// delegate rendering to our first standalone component
		template: '<App/>',
		components: {App},
		i18n: new VueI18n({
			locale: langIso,
			messages
		})
	});

	store.dispatch(RESTORE_LOCAL_STORAGE_DATA);

	moment.locale(langIso);

	window.iFrameResizer = {
		onReady: () => {
			let style = document.createElement('style');
			document.head.appendChild(style);
			style.sheet.insertRule('body .q-layout { min-height:auto !important; }', 0);
			style.sheet.insertRule('body .q-dialog__inner { top: unset;bottom: unset; }', 0);
		}
	};
}